import api from "@/utils/request";

interface UserInfo {
  userName: string,
  password: string
}
//qs.stringify(obj)
// headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//     },
export interface ApiResponse {
  result?: any; // 返回结构
  status: any;
}
export const login = async (obj: UserInfo) => {
  let result:ApiResponse = {
    result:{},
    status:{}
  }
  await api.request({
        method: 'post',
        url: '/hive/auth/login',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(obj),
    }).then(res => {
        result = res
    })
  return result
}